import { Field } from "chorda-bulma";
import { FaIcon, TextInput } from "../../../helpers";
import { FieldIcons } from "../../../form/field/with-icon";
import { withMix } from "../../../utils";
import { faRocket } from "@fortawesome/free-solid-svg-icons";
export const MdnSearchSimple = (props) => {
    return Field({
        as: withMix(FieldIcons({
            rightIcon: FaIcon({ icon: faRocket })
        }), {
            styles: {
                display: 'inline-flex',
                minWidth: 300,
            },
            templates: {
                control: {
                    styles: {
                        width: '100%'
                    }
                }
            }
        }),
        control: TextInput({
            onFocus: props.onFocus,
            value$: props.value$,
            onInput: props.onInput,
            placeholder: props.placeholder,
        })
    });
};
